import * as React from 'react';
import { FC, useCallback, useMemo } from 'react';

import { useRouter } from 'expo-router';

import {
  groupAndSortTransactionsByMonth,
  useTransactionDateFormatters,
} from 'pages/loyalty/transactions/utils';
import { routes } from 'utils/routing';

import { HistoryHeader } from './history-header';
import { HistoryLazyTableList } from './history-lazy-table';
import { getTransactionTableHistoryStructure } from './transaction-table-structure';
import { ILoyaltyHistoryViewProps, TransactionTable, TransactionTableRow } from './types';

export const LoyaltyHistoryView: FC<React.PropsWithChildren<ILoyaltyHistoryViewProps>> = ({
  tableData,
  visibleTransactions,
  loadingMore,
}) => {
  const { getMonth } = useTransactionDateFormatters();
  const router = useRouter();

  const tables: TransactionTable[] = useMemo(() => {
    const sortedTransactions = groupAndSortTransactionsByMonth(tableData);
    return sortedTransactions.map(([, data]) =>
      getTransactionTableHistoryStructure(data, getMonth(data[0]) as string)
    );
  }, [getMonth, tableData]);

  const handleOnPressRow = useCallback(
    (row: TransactionTableRow | Partial<TransactionTableRow>) => {
      if (row?.rbiOrderId) {
        // support crowns etc have no order id and shouldn't do anything when clicked
        router.navigate(routes.orderDetails(row?.rbiOrderId));
      }
    },
    [router]
  );

  return (
    <>
      <HistoryHeader />
      <HistoryLazyTableList
        tables={tables}
        visibleTransactions={visibleTransactions}
        handleOnPressRow={handleOnPressRow}
        loadingMore={loadingMore}
      />
    </>
  );
};
